import "./style.less"
import {useStaffController} from "../../controllers/staff-controller";


const StaffPage = () => {
  const {
    editStaffButtonHandler,
    toggleCreateModal,
    isCreateModalOpen,
    staffForm,
    staffList,
    createStaffHandler,
    selectedStaff,
    isDetailModalOpen,
    toggleDetailModal
  } = useStaffController()

  const navigateToHelsiHandler = (helsiId: string | undefined) => {
    if (helsiId) {
      window.open(`https://helsi.me/doctor/${helsiId}`, "blank")
    }
  }

  return <div className="staffPage_wrapper">
    {/*<PageHeader*/}
    {/*  title={*/}
    {/*    <div className="page-header_title">*/}
    {/*      <div className="page_name">Лікарі</div>*/}
    {/*    </div>*/}
    {/*  }*/}
    {/*  onBack={goToPreviousPage}*/}
    {/*  extra={<AddButton onClick={()=>{toggleCreateModal({selectedStaff: undefined, isModalOpen: true})}}/>}*/}
    {/*/>*/}
    {/*<div className="staff_list">*/}
    {/*  {staffList.map(staffItem =>  <StaffCard editStaffButtonHandler={editStaffButtonHandler} toggleDetailsModal={toggleDetailModal} staffItem={staffItem} navigateToHelsiHandler={navigateToHelsiHandler}/>)}*/}
    {/*</div>*/}
    {/* <StaffDetailModal navigateToHelsiHandler={navigateToHelsiHandler} selectedStaff={selectedStaff} isModalOpen={isDetailModalOpen} toggleDetailsModal={toggleDetailModal}/>*/}
    {/*  <CreateStaffModal selectedStaff={selectedStaff} createStaffHandler={createStaffHandler} staffForm={staffForm} toggleCreateModal={toggleCreateModal} isModalOpen={isCreateModalOpen}/>*/}
  </div>
}

export default StaffPage